import { Component, input } from '@angular/core';

import { ProjectStatus } from '@camelot/services';
import { ColorType } from '@camelot/styles';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent, BulletComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationProject } from '../../../../translation.service';

export const projectStatusLabel = (status: ProjectStatus) =>
  `project.projects.status.${ProjectStatus[status]?.toLowerCase() ?? 'unknown'}`;

@Component({
  selector: 'cam-project-status',
  templateUrl: './project-status.component.html',
  styleUrls: ['./project-status.component.scss'],
  imports: [BadgeComponent, BulletComponent, TranslatePipe],
})
export class CamProjectStatusComponent extends CamBaseComponent {
  status = input.required<ProjectStatus>();

  noLabel = input(false);

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }

  get color(): ColorType {
    switch (this.status()) {
      case ProjectStatus.Done:
        return 'success';
      case ProjectStatus.Pending:
        return 'purple';
      case ProjectStatus.InProgress:
        return 'default';
      case ProjectStatus.Cancelled:
        return 'secondary';
      default:
        return 'purple';
    }
  }

  get label(): string {
    if (this.noLabel()) {
      return '';
    }

    const statusKey = ProjectStatus[Number(this.status())];
    return `project.projects.status.${statusKey?.toLowerCase() ?? 'unknown'}`;
  }
}
